import $ from 'jquery'
import pushy from 'pushy'
import sideNavBottomLinks from './sideNav-bottomLinks.html'
import session from '@/auth/models/session'
import authChannel from '@/auth/channel'
import navChannel from './channel'
import expandCollapseUi from './expandCollapseUi'
import { cartPagePath } from '@/utils/cartTransitionUtils'
import { signOut } from '@/services/account'

const $menu = $('.side-nav-xs')
pushy({
  menu: $menu,
  trigger: '#header .menu-btn'
})
const $sideNavBottomLinks = $(sideNavBottomLinks)
// Adding cart page link dynamically to decide between Mercury and Avetti
$sideNavBottomLinks.find('.cart-page-link').attr('href', cartPagePath)
const $signInLink = $sideNavBottomLinks.add($menu).find('.side-nav-signin')
$signInLink.on('click', function (e) {
  e.preventDefault()
  e.stopPropagation()
  // Don't let tracking see this click, so that there's no delay
  if (session.isSignedIn()) {
    // Clear session in local storage and sign out of Avetti
    signOut()
  } else {
    navChannel.trigger('sideNav:close')
    authChannel.request('signin')
  }
})
const updateSignInStatus = function () {
  // Get the logged-in user's first name from their session. If this exists, we assume they're logged in.
  // It's possible the user may be logged into their stateless session, but their Avetti session may have
  // expired. In this case, signedIn will still be populated.
  const signedIn = session.isSignedIn()
  const newLoginHref =
    '/cards/' +
    (signedIn ? 'signout' : 'register') +
    '.html?vid=20090115001&mt=1&redirecturl=' +
    (location.pathname.indexOf('/eco/personalize') >= 0
      ? encodeURIComponent('/cards/register.html?vid=20090115001&mt=1')
      : encodeURIComponent(location.pathname + location.search))
  $signInLink.text(signedIn ? 'Sign Out' : 'Sign In')
  $signInLink.attr('href', newLoginHref)
}
session.on('change:token', () => updateSignInStatus())
updateSignInStatus()
$('.side-nav-xs .collapse-container__section-title').on('click', function (e) {
  const $link = $(this)
  const $outerItem = $link.parent()
  expandCollapseUi(e, $outerItem)
})
